import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { InAppBrowser } from "@ionic-native/in-app-browser";

@Component({
  selector: 'page-xp-unit-reports',
  templateUrl: 'xp-unit-reports.html'
})
export class XpUnitReportsPage {

  unit: any;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public iab: InAppBrowser
  ) {
    this.unit = navParams.get('unit');
  }

  openFile(file){
    if(file.download_url){
      this.iab.create(file.download_url, '_system');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-unit-reports/xp-unit-reports.ts